import React from 'react'
import { Alert } from 'antd'

export const ORG_DRAFT_CHILD_READ_ONLY_TITLE = 'Viewing in Read-Only Mode'

export const ORG_DRAFT_CHILD_READ_ONLY_MESSAGE =
    'This draft is part of a multi-domain notification, so it can only be edited, scheduled, or sent from the organization.'

/**
 * Shown at domain level above the audience builder when the loaded notification is a domain's
 * part of a multi-domain org draft. Mirrors the segment builder's multi-domain read-only notice:
 * a warning that cannot be dismissed, with no link to the organization view.
 */
export const OrgDraftBanner = () => {
    return (
        <Alert
            className="org-draft-banner"
            type="warning"
            title={ORG_DRAFT_CHILD_READ_ONLY_TITLE}
            description={`${ORG_DRAFT_CHILD_READ_ONLY_MESSAGE} You can still review its details below.`}
        />
    )
}

/**
 * Disables every form control beneath it while `active`. Several builder controls pass their own
 * `disabled` to antd, which takes precedence over the disabled state of their group, so a
 * read-only view cannot rely on props alone; a disabled fieldset disables all descendant controls.
 */
export const OrgDraftReadOnlyFieldset = ({ active, children }: React.PropsWithChildren<{ active: boolean }>) => {
    if (!active) {
        return <>{children}</>
    }

    return (
        <fieldset
            disabled={true}
            className="org-draft-read-only"
            style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}
        >
            {children}
        </fieldset>
    )
}
